import { Map, List } from 'immutable';
import { TYPES } from './actions';
import { SESSION_DESTROY } from '../../actions';
import Logger from '../../../lib/Logger';

const initialState = Map({
  isLoading: false,
  cognitoFormId: null,
  cognitoFormKey: null,
  form: {},
  isGeneratingPDF: false,
});

export default function cognitoFormAnswers(state = initialState, action) {
  Logger.log(
    'debug',
    `[state.cognitoFormAnswers.reducers] cognitoFormAnswers(%j, %j)`,
    state,
    action
  );

  switch (action.type) {
    case TYPES.ONBOARDING_READ_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case TYPES.ONBOARDING_READ_SUCCESS:
      return state
        .mergeDeep({
          isLoading: false,
          lastUpdated: action.receivedAt,
        })
        .setIn(
          ['cognitoFormAnswer', action.partnershipId, action.careGuideId],
          action.id
        );

    case TYPES.ONBOARDING_READ_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case TYPES.CHECK_ONBOARDING_ANSWER_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case TYPES.CHECK_ONBOARDING_ANSWER_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        lastUpdated: action.receivedAt,
      });

    case TYPES.CHECK_ONBOARDING_ANSWER_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case TYPES.CREATE_COGNITO_FORM_SKIP_REQUEST:
      return state.mergeDeep({
        form: {
          isSubmitting: true,
          success: null,
          errors: null,
        },
      });

    case TYPES.CREATE_COGNITO_FORM_SKIP_SUCCESS:
      return state.mergeDeep({
        form: {
          isSubmitting: false,
          success: true,
          errors: null,
        },
        lastUpdated: action.receivedAt,
      });

    case TYPES.CREATE_COGNITO_FORM_SKIP_FAILURE:
      return state
        .mergeDeep({
          form: {
            isSubmitting: false,
            success: false,
            errors: null,
          },
        })
        .setIn(['form', 'errors'], action.error);

    case TYPES.LIST_SUCCESS:
      return state
        .mergeDeep({
          isLoading: false,
          pages: {
            [action.partnershipId]: {
              [action.careGuideId]: {
                [action.cognitoFormId]: {
                  [action.page]: {
                    [action.limit]: {
                      [action.order]: null,
                    },
                  },
                },
              },
            },
          },
          total: action.total,
          lastUpdated: action.receivedAt,
        })
        .setIn(
          [
            'pages',
            action.partnershipId,
            action.careGuideId,
            action.cognitoFormId,
            action.page,
            action.limit,
            action.order,
          ],
          List(action.result)
        );

    case TYPES.LIST_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case TYPES.DELETE_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case TYPES.DELETE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        lastUpdated: action.receivedAt,
      });

    case TYPES.DELETE_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case TYPES.PDF_REQUEST:
      return state.mergeDeep({
        isGeneratingPDF: true,
      });

    case TYPES.PDF_SUCCESS:
      return state.mergeDeep({
        isGeneratingPDF: false,
        lastUpdated: action.receivedAt,
      });

    case TYPES.PDF_FAILURE:
      return state.mergeDeep({
        isGeneratingPDF: false,
      });

    case SESSION_DESTROY:
      return initialState;

    default:
      return state;
  }
}

Logger.log('silly', `state.cognitoFormAnswers.reducers loaded.`);
